<template>
  <div>
    <loading :active.sync="isLoading"
             :can-cancel="false"
             color="#007BFF"
             :is-full-page="true">
    </loading>
    <base-header class="pb-6">
    </base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <div class="row align-items-center">
            <div class="col">
<!--              <h3 class="mb-0">Detalles de Bonificación</h3>-->
              <div class="d-inline-block pl-2">
                SUMA TOTAL: {{ parseFloat(bono_final).toFixed(2) }}
              </div>
            </div>
            <div class="d-inline-block pl-2">
              Periodo:
              <base-input addon-left-icon="ni ni-calendar-grid-58">
                <flat-picker slot-scope="{focus, blur}"
                             @on-open="focus"
                             @on-close="blur"
                             :config="dates.config"
                             class="form-control datepicker"
                             placeholder="Seleccione fecha"
                             @input="dateRangeChange"
                             v-model="dates.range">
                </flat-picker>
              </base-input>
            </div>
<!--            <div class="col text-right">-->
<!--              <a href="#" class="btn btn-sm btn-primary">See all</a>-->
<!--            </div>-->

          </div>
        </div>

        <el-table class="table-responsive table"
                  v-if="bonification.nps < 55"
                  :data="nps"
                  header-row-class-name="thead-light">
          <el-table-column label="FACTOR DE NPS"
                           sortable
                           min-width="130px"
                           prop="page">
            <template v-slot="{row}">
              <div class="font-weight-600">{{row.label}}</div>
            </template>
          </el-table-column>
          <el-table-column label="PORCENTAJE"
                           sortable
                           min-width="90px"
                           prop="bounceRate">
            <template v-slot="{row}">
              <i class="fas fa-arrow-up text-success mr-3 text-danger"
                 :class="bonification.nps < 55 ? 'text-success': 'text-danger'">
                >
              </i>
              {{parseFloat(bonification.nps_rate).toFixed(2)}}%
            </template>
          </el-table-column>
        </el-table>

        <el-table class="table-responsive table"
                  v-if="bonification.tardies_factor !== 0"
                  :data="tardies"
                  header-row-class-name="thead-light">
          <el-table-column label="FACTOR DE RUTAS"
                           sortable
                           min-width="130px"
                           prop="page">
            <template v-slot="{row}">
              <div class="font-weight-600">{{row.label}}</div>
            </template>
          </el-table-column>
          <el-table-column label="PORCENTAJE"
                           sortable
                           min-width="90px"
                           prop="bounceRate">
            <template v-slot="{row}">
              <i class="fas fa-arrow-up text-danger mr-3">
              </i>
              -{{parseFloat(bonification.tardies_factor).toFixed(2)}}%
            </template>
          </el-table-column>
        </el-table>


        <el-table class="table-responsive table"
                  v-if="bonification.claims_factor.length > 0"
                  :data="bonification.claims_factor"
                  header-row-class-name="thead-light">
          <el-table-column label="FACTOR DE CHECKLIST"
                           sortable
                           min-width="130px"
                           prop="page">
            <template v-slot="{row}">
              <div class="font-weight-600">{{row.label}}</div>
            </template>
          </el-table-column>
          <el-table-column label="PORCENTAJE"
                           sortable
                           min-width="90px"
                           prop="bounceRate">
            <template v-slot="{row}">
              <i class="fas fa-arrow-up text-success mr-3"
                 :class="row.percentage > 0 ? 'text-success': 'text-danger'">
              </i>
              {{parseFloat(row.percentage).toFixed(2)}}%
            </template>
          </el-table-column>
        </el-table>

        <el-table class="table-responsive table"
                  v-if="bonification.checklist_factor.length > 0"
                  :data="bonification.checklist_factor"
                  header-row-class-name="thead-light">
          <el-table-column label="FACTOR DE RECLAMOS"
                           sortable
                           min-width="130px"
                           prop="page">
            <template v-slot="{row}">
              <div class="font-weight-600">{{row.label}}</div>
            </template>
          </el-table-column>
          <el-table-column label="PORCENTAJE"
                           sortable
                           min-width="90px"
                           prop="bounceRate">
            <template v-slot="{row}">
              <i class="fas fa-arrow-up text-success mr-3"
                 :class="row.percentage > 0 ? 'text-success': 'text-danger'">
              </i>
              {{parseFloat(row.percentage).toFixed(2)}}%
            </template>
          </el-table-column>
        </el-table>

        <el-table class="table-responsive table"
                  v-if="evaluation_discount !== 0"
                  :data="evaluation_recipes"
                  header-row-class-name="thead-light">
          <el-table-column label="Aprobación de recetas"
                           sortable
                           min-width="130px"
                           prop="page">
            <template v-slot="{row}">
              <div class="font-weight-600">{{row.label}}</div>
            </template>
          </el-table-column>
          <el-table-column label="PORCENTAJE"
                           sortable
                           min-width="90px"
                           prop="bounceRate">
            <template v-slot="{row}">
              -1
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="col-lg-12"
          v-if="
        (bonification.nps < 55 && bonification.nps !== null) ||
        bonification.tardies_factor !== 0 ||
        bonification.checklist_factor.length > 0 ||
        bonification.claims_factor.length > 0
          "
      >
        <card header-classes="bg-transparent">
          <h3 slot="header" class="mb-0">¿Qué puedo hacer para mejorar mi desempeño?</h3>
        <ul>
          <li v-if="bonification.nps < 55 && bonification.nps != null">
            <div>
              <p class=" text-sm mt-1 mb-0">
                EL NPS es un indicador de desempeño muy importante y describe que tanto
                nuestros clientes recomendarían el producto. Si tu producto es percibido como
                de baja calidad, los clientes no lo recomendarán. Para elevar tu NPS es
                importante cuidar los detalles.
              </p>
            </div>
          </li>

          <li v-if="bonification.tardies_factor !== 0">
            <div>
              <p class=" text-sm mt-1 mb-0">
                Revisa en que está fallando tu proceso. ¿Tu equipo esta completo? ¿Tus insumos precortados? ¿Tienes todo lo necesario para las preparaciones? Trabaja mediante procesos eficientes, a fin de que puedas tener todos los platos listos para que las rutas salgan a su hora. Este tratabajo no tiene fin, es un proceso de mejora continua y no acabará nunca.
              </p>
            </div>
          </li>

          <li v-if="bonification.checklist_factor.length > 0" v-for="check in bonification.checklist_factor" v-bind:key="check.id">
            <div v-if="check.response">
              <p class=" text-sm mt-1 mb-0">
                {{check.response}}
              </p>
            </div>
          </li>

          <li v-if="bonification.claims_factor.length > 0" v-for="claim in bonification.claims_factor" v-bind:key="claim.id">
            <div v-if="claim.response">
              <p class=" text-sm mt-1 mb-0">
                {{claim.response}}
              </p>
            </div>
          </li>
        </ul>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import Badge from '@/components/Badge';
  import { Table, TableColumn, Select, Option } from 'element-ui';
  import { VueContentLoading } from 'vue-content-loading'
  import axios from 'axios'
  import flatPicker from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css';
  import { Spanish } from 'flatpickr/dist/l10n/es'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    name: "ListBonification",
    components:{
      Badge,
      VueContentLoading,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      flatPicker,
      Loading
    },
    data(){
      return {
        isLoading: false,
        dates: {
          range: "",
          config:{allowInput: false, mode: 'range',locale: Spanish}
        },
        rangeDate:[],
        bonification:{
          total:0,
          nps:null,
          nps_rate:null,
          tardies_factor:0,
          claims_factor:[],
          checklist_factor:[],
        },
        evaluation_recipes:[
          {
            label:'Aprobación de recetas'
          }
        ],
        tardies:[
          {
            label:'Ruta Tarde'
          }
        ],
        nps:[
          {
            label:'NPS < 55%'
          }
        ],
        evaluation_discount: 0,
        bono_final : 0
      }
    },
    created(){
      const days_of_week = this.getDaysOfWeek();
      this.dates.range = `${days_of_week[0]} a ${days_of_week[days_of_week.length - 1]}`;
      this.rangeDate = [
        days_of_week[0],
        days_of_week[days_of_week.length - 1],
      ]
    },
    methods:{
      getBonification(){
        this.isLoading = true
         axios.get('/bonifications/',{
          params: {
            range: this.rangeDate
          }
        })
          .then(response => {
             this.bonification = response.data.bonusData
            this.evaluation_discount = response.data.evaluation_discount
            if(this.evaluation_discount > 0) {
              this.bono_final = this.bonification.total - 1
            }else {
              this.bono_final = this.bonification.total
            }
          }).finally(() => {
            this.isLoading = false
         });
      },
      getDaysOfWeek() {
        return [
          moment().startOf('week').format('YYYY-MM-DD'),
          moment().endOf('week').format('YYYY-MM-DD'),
        ]
      },
      dateRangeChange(val){
        const dates = val.split('a').map(item => {
          return item.trim()
        });
        dates.length === 2 ? this.rangeDate = dates : '';
      }
    },
    watch:{
      rangeDate(val){
        this.getBonification()
      }
    }
  }
</script>
